/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AbstractInputs */

const en_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstract`)
};

const es_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstracta`)
};

const fr_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrait`)
};

const de_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrakt`)
};

const ja_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽象画`)
};

const zh_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽象摄影`)
};

const ar_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجريدي`)
};

const id_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrak`)
};

const it_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Astratto`)
};

const ru_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абстрактная`)
};

const pt_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrato`)
};

const ko_val_abstract = /** @type {(inputs: Val_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추상`)
};

/**
* | output |
* | --- |
* | "Abstract" |
*
* @param {Val_AbstractInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_abstract = /** @type {((inputs?: Val_AbstractInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AbstractInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_abstract(inputs)
	if (locale === "es") return es_val_abstract(inputs)
	if (locale === "fr") return fr_val_abstract(inputs)
	if (locale === "de") return de_val_abstract(inputs)
	if (locale === "ja") return ja_val_abstract(inputs)
	if (locale === "zh") return zh_val_abstract(inputs)
	if (locale === "ar") return ar_val_abstract(inputs)
	if (locale === "id") return id_val_abstract(inputs)
	if (locale === "it") return it_val_abstract(inputs)
	if (locale === "ru") return ru_val_abstract(inputs)
	if (locale === "pt") return pt_val_abstract(inputs)
	return ko_val_abstract(inputs)
});